// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"487":"c29be88d","990":"abf1cb54"}[chunkId] + ".chunk.js";
};